import { Component, OnInit, NgModule, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, FormArray, Validators, ValidatorFn, AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { InternalUser } from '../../../entities/internal-user';
import { UserService } from '../../../../framework/services/userservice';
import { SidebarModule } from 'primeng/sidebar';
import { LogoManagementService } from '../../../../framework/services/logo-mgmt.service';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { AppConfigService } from '../../../../framework/services/app-config.service';
import { CommonService } from '../../../../framework/services/common.service';
import { NgxSpinnerService } from 'ngx-spinner'
import { CustomMessageService } from '../../../../framework/services/custom-message.service';
import { AddEngagementMemoryService } from '../../add-engagement-memory-service/add-engagement-memory.service';
import { element } from 'protractor';
import { Observable, of } from 'rxjs';
import { CategoryConstant } from 'src/app/shared/app-constants/category-constants';
import { LanguageService } from 'src/framework/services/language.service';
import { ImageType } from 'src/app/enums/image-type';
import { LogoIconMgmtService } from 'src/framework/services/logo-icon-mgmt.service';

@Component({

  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.css']
})

@NgModule({
  imports: [
    SidebarModule,
  ],
  declarations: [],
  providers: []
})

export class ContactsComponent implements OnInit {
  editing = true;
  emailList: any = [];
  selectedLanguages: any[] = [];

  displayInternalUserDropDown = true;
  isSaveButtonEnable: boolean = true;
  //internal Contacts
  internalContactColumns: any[];
  internalContactsTableData: any[] = [];
  internalContactModel: InternalUserModel;
  userDropDownData: any = [];
  userRoles = [];
  internalContactRowIndex: number = 0;

  //externalContactsRoles
  externalRoleColumns: any = [];
  externalRolesTableData = [];
  externalContactRoleRowIndex: number = 0;


  //externalContacts
  externalContactColumns: any[];
  externalContacts: any[] = [];
  externalContactModel: ExternalContactModel;
  externalContactRoleModel = [];
  logoList: SelectItem[];
  externalContactRowIndex: number = 0;

  displayInternalContactDialog: boolean;
  displayRoleDialog: boolean;
  displayExternalDialog: boolean;
  externalRoleDropDown: any = [];
  isEnglishLanguageSelected: boolean = false;
  isFrenchLanguageSelected: boolean = false;

  addInternalUserForm: FormGroup;
  externalContactSectionRole: FormGroup;
  externalContactForm: FormGroup;

  duplicateIntenalUsers: any = "";
  clonedRolesTableData = [];
  clonedExternalTableData = [];

  selectedLanguageId: number;
  defaultEnglishJson: any;
  islabelLoaded: boolean = false;
  selectedAppLanguageJson: any;
  selectedLangStatusJson: any;
  defaultEngStatusJson: any;
  selectedLangLabelJson: any;
  defaultEngLangLabelJson: any;
  loggedInUserModel: any;

  @Output() showNextControl = new EventEmitter<string>()
  @Output() showPreviousControl = new EventEmitter<string>();
  editInternalContactRowIdex: number = -1;

  constructor(private userService: UserService,
    private logoManagementService: LogoManagementService,
    private confirmationService: ConfirmationService,
    private appConfigService: AppConfigService,
    private commonService: CommonService,
    private languageSerivce: LanguageService,
    private engagementMemoryService: AddEngagementMemoryService,
    private fb: FormBuilder,
    public messageService: MessageService,
    private customMessageService: CustomMessageService,
    private ngxSpinner: NgxSpinnerService,
    private logoIconMgmtService: LogoIconMgmtService) {
    this.externalContacts = new Array<ExternalContactModel>();
    this.internalContactModel = new InternalUserModel();
    this.internalContactsTableData = new Array<InternalUserModel>();
    this.externalContactModel = new ExternalContactModel(0, "", "", "", "", true, '', '', '')
    this.selectedLanguages = this.engagementMemoryService.getSelectedLanguages();

    this.externalContactSectionRole = this.fb.group({
      "externalRoleControls": this.fb.array([])
    });
    this.addInternalUserForm = new FormGroup({
      'internalRoleCtrl': new FormControl('', [this.internalRoleValidation()]),
      'internalUserCtrl': new FormControl('', [this.internalUserSelectValidation(), this.userDuplicateValidator(), this.reviewerValidator()]),
      'internalEmailCtrl': new FormControl('', [Validators.email]),
      'internalIsDisplayCtrl': new FormControl(false),
      'internalContactCtrl': new FormControl(this.internalContactModel.contactNumber),
      'internalFaxNo': new FormControl(this.internalContactModel.faxNumber)
    });
    this.externalContactForm = new FormGroup({
      'externalRoleCtrl': new FormControl(this.externalContactModel.selectedRole, [Validators.required]),
      'externalContactNameCtrl': new FormControl(this.externalContactModel.contactName, [Validators.required]),
      'externalEmailCtrl': new FormControl(this.externalContactModel.email, [Validators.email]),
      'externalContactPhoneCtrl': new FormControl(this.externalContactModel.phoneNumber),
      'externalContactLanguageCtrl': new FormControl(this.externalContactModel.selectedLangages, [Validators.required]),
      'externalContactLogoCtrl': new FormControl(this.externalContactModel.selectedLogo, [Validators.required]),
      'externalIsDisplayCtrl': new FormControl(true),
      'externalContactFaxNoCtrl': new FormControl(this.externalContactModel.faxNo)
    })
  }

  ngOnInit(): void {
    this.loadLanguageLabel();
    this.getExternalContactLogoList();
    if (this.selectedLanguages.length > 0) {
      let actualLanguageSelected = this.engagementMemoryService.getActualLanguageSelected();
      this.selectedLanguages.forEach(element => {
        if (element.languageId == 1)
          this.isEnglishLanguageSelected = true;

        for (let i = 0; i < actualLanguageSelected.length; i++) {
          if (actualLanguageSelected[i].languageId == element.languageId) {
            this.externalRoleColumns.push({ field: actualLanguageSelected[i].name, header: element.name, });
            this.externalContactRoleModel.push({ language: actualLanguageSelected[i].name, value: '', });
            (<FormArray>this.externalContactSectionRole.get('externalRoleControls')).controls.push(this.fb.group({
              'externalRoleControl': ['', [Validators.required]]
            }));
            break;
          }
        }
      })
      if (!this.isEnglishLanguageSelected)
        this.isFrenchLanguageSelected = true;
    }
    this.loadContactDetails();
    this.loggedInUserModel = JSON.parse(localStorage.getItem('userModel'));
  }


  getUserList(roleId) {
    this.ngxSpinner.show();
    this.userService.getUserListByRoleId(roleId).subscribe((response: any) => {
      if (response.responseStatus == 1) {

      } else {
        if (response.data && response.data.length > 0)
          this.userDropDownData = response.data.map(t => ({
            userName: t.firstName + " " + t.lastName,
            userId: t.userId,
            emailId: t.emailId
          }))
        else {
          this.userDropDownData = [];
        }
      }
      this.ngxSpinner.hide();
    });
  }

  getExternalContactLogoList() {
    this.ngxSpinner.show();
    this.logoManagementService.GetExternalContactLogoList().subscribe((response: any) => {
      if (response.data) {
        this.logoList = response.data.map(x => ({
          label: x.logoName,
          value: x.logoIconImageDataId,
          result: 'data:image/png;base64,' + x.result
        }));
      }
      this.getUserRoles();
      this.loadContactDetails();
      this.ngxSpinner.hide();
    });
  }

  showInternalContactDialogToAdd() {
    this.resetAddInternalContact();
    this.displayInternalContactDialog = true;
  }

  getUserByRole(event) {
    if (event && event.value) {
      this.internalContactModel.roleId = event.value.userRoleId;
      this.internalContactModel.roleName = event.value.role;
      this.internalContactModel.selectedUser = {};
      this.internalContactModel.email = "";
      this.getUserList(event.value.userRoleId)
    }
  }

  AddInternalContact() {
    if (!this.addInternalUserForm.invalid) {
      this.internalContactModel.rowIndex = this.internalContactRowIndex;
      this.internalContactRowIndex++;
      let model = { ...this.internalContactModel }
      this.internalContactsTableData.push(model);
      this.internalContactsTableData.sort((a, b) => {
        if (a.userName > b.userName)
          return 1;
        if (b.userName > a.userName)
          return -1
        return 0;
      })
      this.displayInternalContactDialog = false;
    } else {
      this.addInternalUserForm.markAllAsTouched();
    }
  }

  resetAddInternalContact() {
    this.addInternalUserForm.reset();
    this.userDropDownData = [];
    this.internalContactModel.rowIndex = 0;
    this.internalContactModel.roleId = 0;
    this.internalContactModel.roleName = "";
    this.internalContactModel.userId = 0;
    this.internalContactModel.userName = "";
    this.internalContactModel.email = "";
    this.internalContactModel.isDisplay = false;
    this.internalContactModel.selectedRole = {};
    this.internalContactModel.selectedUser = {};
    this.duplicateIntenalUsers = "";
    this.internalContactModel.contactNumber = "";
    this.isSaveButtonEnable = true;
    //this.externalContactRoleRowIndex = -1;
    this.internalContactModel.faxNumber = "";
  }

  onInternalContactEditInit(rowData) {
    this.ngxSpinner.show();
    this.resetAddInternalContact();
    this.getUserList(rowData.roleId);
    this.displayInternalContactDialog = true;
    setTimeout(() => {
      this.ngxSpinner.show();
      this.internalContactModel = { ...rowData }
      this.duplicateIntenalUsers = { ...rowData };
      this.editInternalContactRowIdex = rowData.rowIndex;
      this.ngxSpinner.hide();
    }, 1000)
    this.isSaveButtonEnable = false;
  }

  showDialogToAddRole() {
    this.resetRolesSection();
    this.displayRoleDialog = true;
  }

  saveRole() {
    let isValid = true;
    (<FormArray>this.externalContactSectionRole.get('externalRoleControls')).controls.forEach(element => {
      if (element.invalid) {
        isValid = false
        return;
      }
    })
    if (isValid) {
      let obj = {};
      obj["rowIndex"] = this.externalContactRoleRowIndex;
      (<FormArray>this.externalContactSectionRole.get('externalRoleControls')).controls.forEach((element, index) => {
        obj[this.externalContactRoleModel[index].language] = element.value.externalRoleControl;
      });
      this.externalRolesTableData.push(obj);
      this.externalContactRoleRowIndex++;
      this.displayRoleDialog = false;
    } else {
      this.externalContactSectionRole.get('externalRoleControls').markAllAsTouched();
    }
  }

  resetRolesSection() {
    this.externalContactSectionRole.get('externalRoleControls').reset();
    (<FormArray>this.externalContactSectionRole.get('externalRoleControls')).controls.forEach((element, index) => {
      element.setValue({ 'externalRoleControl': '' });
    });
  }

  showDialogToAddExternal() {
    if (this.externalRolesTableData.length > 0) {
      this.resetExternalContactUser();
      this.loadExternalRoles();
      this.displayExternalDialog = true;
    }
  }


  loadLanguageLabel() {
    let englishLanguageMappings, selectedLanguageMappings: any;
    let englishStatusMappings, selectedLangStatusMappings: any;
    let englishLangLabelMappings, selectedLangLabelMappings: any;

    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem('selectedLanguageId')) {
        this.selectedLanguageId = 1;//JSON.parse(sessionStorage.getItem('selectedLanguageId'));
      }
      this.languageSerivce.currentData.subscribe(data => {
        this.selectedLanguageId = data.Id
      });


      this.languageSerivce.mySubject.subscribe((data) => {
        var languageMappings = data;
        if (languageMappings?.length > 0) {

          englishLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.AddEngagement.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishStatusMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishLangLabelMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          if (englishLanguageMappings?.isGlobal) {
            selectedLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.AddEngagement.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

            selectedLangStatusMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

            selectedLangLabelMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
          }
          else {
            if (Number(this.selectedLanguageId) === 2) {
              selectedLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.AddEngagement.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];


              selectedLangStatusMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];

              selectedLangLabelMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
            }
            else {
              selectedLanguageMappings = englishLanguageMappings;
              selectedLangStatusMappings = englishStatusMappings;
              selectedLangLabelMappings = englishLangLabelMappings;
            }
          }

          this.selectedAppLanguageJson = JSON.parse(selectedLanguageMappings.languageMappingJSON);

          this.defaultEnglishJson = JSON.parse(englishLanguageMappings.languageMappingJSON);

          this.selectedLangLabelJson = JSON.parse(selectedLangLabelMappings?.languageMappingJSON ?? englishLangLabelMappings.languageMappingJSON);
          this.defaultEngLangLabelJson = JSON.parse(englishLangLabelMappings.languageMappingJSON);

          this.selectedLangStatusJson = JSON.parse(selectedLangStatusMappings?.languageMappingJSON ?? englishStatusMappings.languageMappingJSON);
          this.defaultEngStatusJson = JSON.parse(englishStatusMappings.languageMappingJSON);
          this.internalContactColumns = [
            { field: 'roleName', header: this.labelReplacer('Role') },
            { field: 'userName', header: this.labelReplacer('Name') },
            { field: 'email', header: this.labelReplacer('EmailId') },
            { field: 'contactNumber', header: this.labelReplacer('PhoneNo') },
            { field: 'faxNumber', header: this.labelReplacer('FaxNo') },
            { field: 'isDisplay', header: this.labelReplacer('Display') }
          ];
          this.externalContactColumns = [
            { field: 'selectedRole', header: this.labelReplacer('Role') },
            { field: 'contactName', header: this.labelReplacer('Name') },
            { field: 'email', header: this.labelReplacer('EmailId') },
            { field: 'phoneNumber', header: this.labelReplacer('PhoneNo') },
            { field: 'faxNo', header: this.labelReplacer('FaxNo') },
            { field: 'language', header: this.labelReplacer('Language') },
            { field: 'logo', header: this.labelReplacer('Logo') },
            { field: 'display', header: this.labelReplacer('Display') }
          ];

          this.islabelLoaded = true;
          resolve(1);
        }
        else {
        }
      });
    })
      .catch(err => {

        console.log(err);
      });
  }


  labelReplacer(labelKey): string {
    return this.selectedAppLanguageJson[labelKey]?.trim() ? this.selectedAppLanguageJson[labelKey] ?? 'text not found' : this.defaultEnglishJson[labelKey] ?? 'text not found';
  }

  languageReplacer(labelKey): string {
    return this.selectedLangLabelJson[labelKey]?.trim() ? this.selectedLangLabelJson[labelKey] ?? 'text not found' : this.defaultEngLangLabelJson[labelKey] ?? 'text not found';
  }


  statusReplacer(labelKey): string {
    return this.selectedLangStatusJson[labelKey]?.trim() ? this.selectedLangStatusJson[labelKey] ?? 'text not found' : this.defaultEngStatusJson[labelKey] ?? 'text not found';
  }



  loadExternalRoles() {
    let roles = [];
    if (this.isEnglishLanguageSelected) {
      roles = this.externalRolesTableData.map(t => ({ value: t.rowIndex, name: t.English }))
    } else if (this.isFrenchLanguageSelected) {
      roles = this.externalRolesTableData.map(t => ({ value: t.rowIndex, name: t.French }))
    }
    this.externalRoleDropDown = roles;
  }

  onNameSelection(event) {
    if (event.value) {
      this.internalContactModel.userId = event.value.userId;
      this.internalContactModel.userName = event.value.userName;
      this.internalContactModel.email = event.value.emailId;
    }
  }

  getUserRoles() {
    this.ngxSpinner.show();
    this.commonService.getUserRoles().subscribe((response) => {
      if (response.responseStatus == 1) {

      } else {
        if (response && response.data.length > 0) {
          this.userRoles = response.data;
          this.userRoles.forEach(item => {
            item.role = this.labelReplacer(item.role);
          })
        }
      }
      this.ngxSpinner.hide();
    });
  }

  saveExternalUser() {
    if (!this.externalContactForm.invalid) {
      this.externalContactModel.rowIndex = this.externalContactRowIndex;
      this.externalContactModel.externalRole = this.externalContactModel.selectedRole.name
      this.externalContactModel.externalRoleId = this.externalContactModel.selectedRole.value;
      this.externalContactModel.selectedLangages.forEach(element => {
        this.externalContactModel.language += element.name + " "
      });
      this.externalContactModel.language = this.externalContactModel.language.trim();
      // this.externalContactModel.logo = this.externalContactModel.selectedLogo;
      this.externalContactModel.logo = this.logoList.find((t) => t.value == this.externalContactModel.selectedLogo)?.label
      this.externalContacts.push({ ...this.externalContactModel });
      this.externalContactRowIndex++;
      this.displayExternalDialog = false;

    } else {
      this.externalContactForm.markAllAsTouched();
    }
  }

  resetExternalContactUser() {
    this.externalContactForm.reset();
    this.externalContactModel = new ExternalContactModel(0, "", "", "", "", true, '', '', '');
    this.externalContactForm.get('externalIsDisplayCtrl').setValue(true);
  }

  onNextButtonClicked(event) {
    let validationModel = this.validateOnNext();
    if (validationModel.isValid) {
      this.engagementMemoryService.setContactDetails(this.internalContactsTableData, this.externalRolesTableData, this.externalContacts);
      this.showNextControl.emit("folderSelection");
    } else {
      this.messageService.add({
        summary: 'Error : ' + this.labelReplacer('Submittingcontacts'),
        detail: validationModel.exceptionMessages[0],
        sticky: false,
        severity: 'error'
      });

    }
  }

  onPreviousButtonClick(event) {
    this.engagementMemoryService.setContactDetails(this.internalContactsTableData, this.externalRolesTableData, this.externalContacts);
    this.showPreviousControl.emit("basicDetails");
  }

  removeInternalUser(rowIndex) {
    this.internalContactsTableData = this.internalContactsTableData.filter(t => t.rowIndex != rowIndex);
  }

  internalRoleValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.touched && control.value) {
        if (control.value?.userRoleId > 0)
          return null;
        return { 'internalUserRoleRequired': 'Select role for internal user' };
      } else if (control.value) {
        return null;
      }
      return { 'internalUserRoleRequired': 'Select internal user' };
    }
  }

  internalUserSelectValidation(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.value?.userId > 0)
        return null;
      if (control.touched && control.value) {
        if (control.value?.userId > 0)
          return null;
        return { 'internalUserRequired': 'Select internal user' };
      }
      return { 'internalUserRequired': 'Select internal user' };
    }
  }

  updateInternalContact() {
    if (!this.addInternalUserForm.invalid) {
      let index = this.internalContactsTableData.findIndex(t => t.rowIndex == this.internalContactModel.rowIndex)
      this.internalContactsTableData[index] = { ...this.internalContactModel };
      this.displayInternalContactDialog = false;
    } else {
      this.addInternalUserForm.markAllAsTouched();
    }
  }

  changesUserSelected(event, rowData: InternalUserModel) {
    this.displayInternalUserDropDown = false
    this.getUserByRole(event);
    let data = this.internalContactsTableData.find(t => t.rowIndex == rowData.rowIndex);
    rowData.email = "";
    rowData.selectedUser = { userName: null, userId: null };
    rowData.userName = "";
    rowData.userId = 0;
    this.displayInternalUserDropDown = true;
  }

  validateInternalUserEdit(rowData: InternalUserModel): { isValid: boolean, exceptionMessages: string[] } {
    let exceptionModel = { isValid: true, exceptionMessages: [] };
    if (!rowData.email) {
      exceptionModel.isValid = false;
      exceptionModel.exceptionMessages.push('Enter internal contact Email')
    }
    if (rowData.email && !rowData.email.match('^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$')) {
      exceptionModel.isValid = false;
      exceptionModel.exceptionMessages.push('Enter valid email for internal contact');
    }
    if (rowData.userId || rowData.userId == 0) {
      exceptionModel.isValid = false
      exceptionModel.exceptionMessages.push('Please select internal user');
    }
    return exceptionModel;
  }

  loadContactDetails() {
    if (this.engagementMemoryService.getInteralContact().length > 0)
      this.internalContactsTableData = [...this.engagementMemoryService.getInteralContact()];
    if (this.engagementMemoryService.getExternalRole().length > 0) {
      this.externalRolesTableData = this.engagementMemoryService.getExternalRole();
      this.loadExternalRoles();
    }
    if (this.engagementMemoryService.getExternalContacts().length > 0) {
      this.externalContacts = this.engagementMemoryService.getExternalContacts();
    }
  }

  validateOnNext(): { isValid: boolean, exceptionMessages: string } {
    let exceptionModel = { isValid: true, exceptionMessages: '' };
    if (this.internalContactsTableData.findIndex(t => t.roleId == 1) == -1) {
      exceptionModel.isValid = false;
      exceptionModel.exceptionMessages += this.labelReplacer('Addatleast1owner\n');
    }
    if (this.internalContactsTableData.findIndex(t => t.roleId == 2) == -1) {
      exceptionModel.isValid = false;
      exceptionModel.exceptionMessages += this.labelReplacer('Addatleast1reviewer\n');
    }
    this.externalContacts.forEach((model, index) => {
      let x = this.validateExternalContactEdit(model)
      if (!x.isValid) {
        exceptionModel.isValid = false;
        exceptionModel.exceptionMessages += 'External Contact Row ' + (index + 1) + ':\n' + x.exceptionMessages;
      }
    })
    return exceptionModel;
  }

  onRowRoleEditInit(rowData) {
    this.clonedRolesTableData.push({ ...rowData });
  }

  onRowRoleEditSave(rowData, index) {
    let validationModel = this.validateExternalRoles(rowData, index)
    if (validationModel.isValid) {
      let index = this.clonedRolesTableData.findIndex(t => t.rowIndex == rowData.rowIndex);
      delete this.clonedRolesTableData[index];
    }
    else {
      this.messageService.add({
        summary: 'Error :' + this.labelReplacer('Updatingroles'),
        detail: validationModel.exceptionMessages,
        sticky: false,
        severity: 'error'
      });
    }
  }

  validateExternalRoles(rowData, index): { isValid: boolean, exceptionMessages: string } {
    index++;
    let exceptionModel = { isValid: true, exceptionMessages: "" }
    this.selectedLanguages.forEach(element => {
      if (!rowData[element.name]) {
        exceptionModel.isValid = false;
        exceptionModel.exceptionMessages += "Row " + index + ":" + this.labelReplacer('PleaseEnterRolefor') + element.name + '\n';
      }
    })
    return exceptionModel;
  }

  onRowRoleEditCancel(rowData) {
    let index = this.clonedRolesTableData.findIndex(t => t.rowIndex == rowData.rowIndex);
    let intialIndex = this.externalRolesTableData.findIndex(t => t.rowIndex == rowData.rowIndex);
    this.externalRolesTableData[intialIndex] = this.clonedRolesTableData[index]
    delete this.clonedRolesTableData[index];
  }

  onDeleteRole(rowIndex) {
    if (this.isvalidateExternalRoleDelete(rowIndex)) {
      this.externalRolesTableData = this.externalRolesTableData.filter(t => t.rowIndex != rowIndex);
    } else {
      this.messageService.add({
        summary: this.labelReplacer('DeleteRelatedExternalContacts'),
        detail: "",
        sticky: false,
        severity: 'error'
      });
    }
  }

  onRowEditInitExternal(rowData: ExternalContactModel) {
    this.clonedExternalTableData.push({ ...rowData });
  }

  onRowEditSaveExternal(rowData: ExternalContactModel) {
    let validationModel = this.validateExternalContactEdit(rowData);
    if (validationModel.isValid) {
      rowData.externalRole = rowData.selectedRole.name;
      rowData.externalRoleId = rowData.selectedRole.value;
      rowData.language = "";
      rowData.selectedLangages.forEach(element => {
        rowData.language += element.name + " "
      });
      rowData.logo = this.logoList.find((t) => t.value == rowData.selectedLogo)?.label
      rowData.language = rowData.language.trim();
      this.clonedExternalTableData = this.clonedExternalTableData.filter(t => t.rowIndex != rowData.rowIndex);
    }
    else {
      this.messageService.add({
        summary: 'Error :' + this.labelReplacer('Updatingexternalcontact'),
        detail: validationModel.exceptionMessages,
        sticky: false,
        severity: 'error'
      });
    }

  }
  validateExternalContactEdit(rowData: ExternalContactModel): { isValid: boolean, exceptionMessages: string } {
    let exceptionModel = { isValid: true, exceptionMessages: "" };
    if (rowData.contactName == "") {
      exceptionModel.isValid = false;
      exceptionModel.exceptionMessages += this.labelReplacer('Entercontactname\n') + "\n";
    } if (rowData.email != '' && !rowData.email.match(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})+$/gm)) {
      exceptionModel.isValid = false;
      exceptionModel.exceptionMessages += this.labelReplacer('Entervalidemail\n') + "\n";
    }
    // if (rowData.phoneNumber != "" && !rowData.phoneNumber.match(/^[0-9-+]*$/im)) {
    //   exceptionModel.isValid = false;
    //   exceptionModel.exceptionMessages += this.labelReplacer('Entervalidphonenumber\n') + "\n";
    // }
    // if (rowData.faxNo != "" && !rowData.faxNo.match(/^[0-9-+]*$/im)) {
    //   exceptionModel.isValid = false;
    //   exceptionModel.exceptionMessages += this.labelReplacer('Entervalidfaxnumber\n') + "\n";
    // }
    if (!rowData.selectedLangages || rowData.selectedLangages.length == 0) {
      exceptionModel.isValid = false;
      exceptionModel.exceptionMessages += this.labelReplacer('Choosethelanguages');
    }
    return exceptionModel;
  }

  onRowEditCancelExternal(rowData: ExternalContactModel, ri) {
    let tempIndex = this.clonedExternalTableData.findIndex(t => t.rowIndex == rowData.rowIndex);
    for (let i = 0; i < this.externalContacts.length; i++) {
      if (this.externalContacts[i].rowIndex == rowData.rowIndex) {
        this.externalContacts[i] = this.clonedExternalTableData[tempIndex];
        break;
      }
    }
    delete this.clonedExternalTableData[tempIndex];
  }

  onDeleteExternalUser(rowData: ExternalContactModel) {
    this.externalContacts = this.externalContacts.filter(t => t.rowIndex != rowData.rowIndex)
  }

  ResetInternalContact() {
    this.ngxSpinner.show();
    if (this.duplicateIntenalUsers != "") {
      this.getUserList(this.duplicateIntenalUsers.roleId)
      setTimeout(() => {
        this.internalContactModel = { ...this.duplicateIntenalUsers };
        this.ngxSpinner.hide();
      }, 2000);
    } else {
      this.resetAddInternalContact();
      this.ngxSpinner.hide();
    }
  }

  ResetRole() {
    this.resetRolesSection()
  }

  ResetExternalUser() {
    this.resetExternalContactUser();
  }

  userDuplicateValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.touched || control.dirty)
        if (control.value.userId && control.value?.userId > 0) {
          let isUserExists = this.internalContactsTableData.findIndex(t => t.userId == control.value.userId && t.rowIndex != this.editInternalContactRowIdex)
          if (isUserExists > -1)
            return { 'userExits': +this.labelReplacer('Jurisdictionisrequired') };
        }
      return null
    }
  }

  reviewerValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (control.touched || control.dirty)
        if (control.value.userId && control.value?.userId > 0) {
          if (this.internalContactModel.selectedRole.userRoleId == 2 && this.loggedInUserModel.rankCode > 21 && !this.loggedInUserModel.isAdmin && this.loggedInUserModel.userId == control.value.userId) {
            return { 'unauthorizedSelection': true }
          }
        }
      return null
    }
  }

  isvalidateExternalRoleDelete(rowIndex): boolean {
    let index = this.externalContacts.findIndex(t => t.externalRoleId == rowIndex)
    if (index > -1)
      return true;
    else
      return false;
  }
}
export class Role {
  roleName: string;
  roleId: number;
}

export class InternalUserModel {
  rowIndex: number;
  roleId: number;
  roleName: string;
  userId: number;
  email: string;
  userName: string;
  isDisplay: boolean
  selectedRole: any;
  selectedUser: any;
  contactNumber: any;
  faxNumber: string
  constructor() {
    this.roleId = 0;
    this.userId = 0;
    this.email = "";
    this.userName = "";
    this.isDisplay = false;
    this.roleName = "";
    this.selectedRole = "";
    this.selectedUser = "";
    this.rowIndex = 0;
    this.contactNumber = "";
    this.faxNumber = '';
  }
}

export class LogoValue {

  value: number;
  label: string;
  //logoLink: string;
  //logoBase4 : any;

  constructor(logoId: number, logoName: string) {
    this.value = logoId;
    this.label = logoName;
    //this.logoLink = logoLink;
    //this.logoBase4 = this.logoBase4;
  }

}
export class ExternalContactModel {
  rowIndex: number;
  externalRole: string;
  contactName: string;
  email: string;
  language: string;
  phoneNumber: string;
  isDisplay: boolean;
  logo: string;
  selectedRole: any;
  selectedLangages: any;
  selectedLogo: any;
  faxNo: string;
  externalRoleId: number;
  constructor(rowIndex: number, externalRole: string, contactName: string, email: string, phoneNumber: string, isDisplay: boolean, language: string, logo: string, faxNo: string) {
    this.rowIndex = rowIndex;
    this.externalRole = externalRole;
    this.contactName = contactName;
    this.email = email;
    this.phoneNumber = phoneNumber;
    this.isDisplay = isDisplay;
    this.selectedRole = '';
    this.selectedLangages = '';
    this.selectedLogo = ''
    this.language = language;
    this.logo = logo;
    this.faxNo = faxNo;
  }

}
